import React, { memo } from 'react'
import classnames from 'clsx'

import FormatCurrency from 'components/Common/FormatCurrency'
import Heading from 'components/Luxkit/Typography/Heading'

interface Props extends Omit<React.ComponentProps<typeof Heading>, 'variant'> {
  price: number;
}

function PriceLine(props: Props) {
  const { price, ...headingProps } = props

  return <Heading
    {...headingProps}
    variant="heading3"
    data-testid={classnames(props['data-testid'], 'price-box')}
  >
    <FormatCurrency value={Math.ceil(props.price)} />
  </Heading>
}

export default memo(PriceLine)
